import map from 'lodash/map'
import * as React from 'react'
import Input from '@frontrow/console/src/entities/components/base/input'
import {sortedCountries} from '@frontrow/console/src/entities/helpers/countries'

import {SELECT_BASE} from '@frontrow/console/src/lib/form-styles'

import {type FilterArgsT} from '@frontrow/console/src/components/common/data-table'

/* Custom Filters */

export function NumberFilter({filter, onChange}: FilterArgsT): React.ReactElement {
  return (
    <Input
      type="number"
      onChange={onChange as (value: string) => void}
      value={filter ? filter.value : ''}
    />
  )
}

export function CountryFilter({filter, onChange}: FilterArgsT): React.ReactElement {
  const options = map(sortedCountries, c => (
    <option key={c.iso3} value={c.iso3}>
      {c.country}
    </option>
  ))
  return (
    <select
      onChange={event => onChange(event.target.value)}
      className={`${SELECT_BASE} w-full`}
      value={filter ? filter.value : ''}
    >
      <option key="" value={''} />
      {options}
    </select>
  )
}

export function YesNoFilter({filter, onChange}: FilterArgsT): React.ReactElement {
  return (
    <select
      onChange={event => {
        onChange(event.target.value)
      }}
      className={`${SELECT_BASE} w-full`}
      value={filter ? filter.value : ''}
    >
      <option value={undefined} />
      <option value="True">Yes</option>
      <option value="False">No</option>
    </select>
  )
}
